import { useEffect, useState } from "react";

export function sendQuoteEmail() {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const emailsEnabled = process.env.REACT_APP_ENABLE_EMAIL_SENDING === "true";
    const customerDetails = JSON.parse(localStorage.getItem('customerDetails') || "");
    const trade = localStorage.getItem('trade') || "";
    const status = localStorage.getItem('status');
    const gclid = localStorage.getItem('gclid');

    let quoteSorted = JSON.parse(localStorage.getItem('quotes') || "");
    quoteSorted = quoteSorted.sort((a: { totalDebt: number; }, b: { totalDebt: number; }) =>
        a.totalDebt > b.totalDebt ? 1 : -1,
    );
    let selectedQuoteObject = quoteSorted[0];
    if (selectedQuoteObject.schemeContent.hasOwnProperty('extensionData')) {
        delete selectedQuoteObject.schemeContent.extensionData;
    }

    if (selectedQuoteObject.quote.hasOwnProperty('extensionData')) {
        delete selectedQuoteObject.quote.extensionData;
    }

    selectedQuoteObject.quote.breakdownsField.forEach((breakdown: { hasOwnProperty: (arg0: string) => any; extensionData: any; }) => {
        if (breakdown.hasOwnProperty('extensionData')) {
            delete breakdown.extensionData;
        }
    });

    if (selectedQuoteObject.quote.endorsementsField != null) {
        selectedQuoteObject.quote.endorsementsField.forEach((endorsement: { hasOwnProperty: (arg0: string) => any; extensionData: any; }) => {
            if (endorsement.hasOwnProperty('extensionData')) {
                delete endorsement.extensionData;
            }
        });
    } else {
        selectedQuoteObject.quote.endorsementsField = [];
    }

    if (selectedQuoteObject.quote.otherOutputsField != null) {
        selectedQuoteObject.quote.otherOutputsField.forEach((otherOutput: { hasOwnProperty: (arg0: string) => any; extensionData: any; }) => {
            if (otherOutput.hasOwnProperty('extensionData')) {
                delete otherOutput.extensionData;
            }
        });
    }

    selectedQuoteObject.quote.paymentPlansField.forEach((paymentPlan: { hasOwnProperty: (arg0: string) => any; extensionData: any; instalmentsField: { hasOwnProperty: (arg0: string) => any; extensionData: any; }[]; }) => {
        if (paymentPlan.hasOwnProperty('extensionData')) {
            delete paymentPlan.extensionData;
        }

        paymentPlan.instalmentsField.forEach(instalment => {
            if (instalment.hasOwnProperty('extensionData')) {
                delete instalment.extensionData;
            }
        });
    });

    selectedQuoteObject.quote.premiumsField.forEach((premium: { hasOwnProperty: (arg0: string) => any; extensionData: any; }) => {
        if (premium.hasOwnProperty('extensionData')) {
            delete premium.extensionData;
        }
    });

    if (selectedQuoteObject.quote.productSummariesField != null) {
        selectedQuoteObject.quote.productSummariesField.forEach((productSummary: { hasOwnProperty: (arg0: string) => any; extensionData: any; }) => {
            if (productSummary.hasOwnProperty('extensionData')) {
                delete productSummary.extensionData;
            }
        });
    }

    selectedQuoteObject.premCovers.forEach((premCover: { hasOwnProperty: (arg0: string) => any; extensionData: any; }) => {
        if (premCover.hasOwnProperty('extensionData')) {
            delete premCover.extensionData;
        }
    });

    selectedQuoteObject.jsonItem.forEach((item: { endorsementItems: any[]; }) => {
        if (item.endorsementItems != null) {
            item.endorsementItems.forEach(endorsement => {
                if (endorsement.hasOwnProperty('extensionData')) {
                    delete endorsement.extensionData;
                }
            });
        } else {
            item.endorsementItems = [];
        }
    });

    if (selectedQuoteObject.quote.excessesField != null) {
        selectedQuoteObject.quote.excessesField.forEach((excess: { hasOwnProperty: (arg0: string) => any; extensionData: any; }) => {
            if (excess.hasOwnProperty('extensionData')) {
                delete excess.extensionData;
            }
        });
    }

    if (emailsEnabled) {
        var tradeDescription = "";
        if (trade !== "") {
            var tradeJSON = JSON.parse(trade);
            tradeDescription = tradeJSON.description;
        }
        let webReference = localStorage.getItem('webReference') || "";
        fetch(`${apiBaseUrl}Email/SendQuoteEmail`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                customerDetails: customerDetails,
                trade: tradeDescription,
                status: status,
                cheapestQuote: selectedQuoteObject,
                webReference: webReference,
                gclid: gclid
            })
        })
            .catch((error) => {
                console.error('Error: ', error);
            });
    } else {
        console.log("Email sending disabled.");
    }
}